import { graphql, useStaticQuery } from 'gatsby';
import _ from 'lodash';
import React from 'react';
import TownCard from './TownCard';

const TownGrid = () => {
  const data = query();

  const areas = data.allDatoCmsNetworkCoverageModel.nodes;

  // Group areas by name, then reduce back down to an array, merging objects if there are multiple areas per town
  const groupedAreas = _.reduce(
    _.groupBy(areas, 'areaName'),
    (result, matchingAreas) => {
      result ??= [];
      result.push(
        _.reduce(matchingAreas, (areaResult, area) => ({
          ...area,
          available: area.available | areaResult.available,
          townSlug: area.townSlug ?? areaResult.townSlug,
        })),
      );
      return result;
    },
  );

  groupedAreas.forEach(
    (area) =>
      (area.id = area.areaName
        .toLowerCase()
        .replaceAll(' ', '')
        .replaceAll("'", '')),
  );

  // Copied groupedAreas to avoid to sorts inteferring with eachother
  const alphabeticalAreas = [...groupedAreas].sort((a, b) =>
    a.areaName > b.areaName ? 1 : -1,
  );

  const sortedAreas = groupedAreas
    .sort((a, b) => (a.areaName > b.areaName ? 1 : -1))
    .sort((a, b) => b.available - a.available)
    .sort((a, b) => b.inBuild - a.inBuild);

  return (
    <section className="container pt-2">
      <div className="row pt-2">
        {sortedAreas.map((area) => (
          <TownCard key={area.areaName} town={area} />
        ))}
      </div>
    </section>
  );
};

export default TownGrid;

const query = () =>
  useStaticQuery(graphql`
    {
      allDatoCmsNetworkCoverageModel {
        nodes {
          available
          inBuild
          areaName
          townSlug {
            slug
            heroImage {
              gatsbyImageData
            }
            mobileHeroImage {
              gatsbyImageData
            }
          }
        }
      }
    }
  `);
